import Yup from '@tmh-website/services/validation.service';

/**
 * The validation has to be separated from the React component,
 * as it is imported in the server-side code as well.
 */

export const CalculatorCarConsumptionFormValidation = Yup.object({
  mileage: Yup.mixed().when('yearlyConsumption', {
    is: value => value > 0,
    then: Yup.mixed(),
    otherwise: Yup.number().positive().required(),
  }),
  consumption: Yup.mixed().when('yearlyConsumption', {
    is: value => value > 0,
    then: Yup.mixed(),
    otherwise: Yup.number().positive().required(),
  }),
  yearlyConsumption: Yup.number().positive().required(),
  chargeHome: Yup.number().positive().required(),
  /**
   * Id of the selected car preset
   */
  vehicleSelection: Yup.number(),
  /**
   * How many hours per day the car is connected to the home charger
   */
  homeConnectionHours: Yup.number(),
});
